import { useEffect, useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const GALLERY_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      "@id": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/gallery#webpage`,
      "url": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/gallery`,
      "name": "Project Gallery – Electrical Work NYC | DTPU Done to Power Up",
      "description": "Browse DTPU's project gallery showcasing completed electrical work across NYC — commercial panel upgrades, EV charger installations, smart home wiring, industrial lighting, and more.",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Home", "item": import.meta.env.VITE_SITE_URL || "https://example.com" },
          { "@type": "ListItem", "position": 2, "name": "Gallery", "item": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/gallery` }
        ]
      }
    },
    {
      "@type": "ImageGallery",
      "name": "DTPU Electrical Project Gallery",
      "description": "Photos of completed electrical projects by Done to Power Up across NYC and Westchester County.",
      "url": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/gallery`,
      "author": { "@type": "ElectricalContractor", "name": "Done to Power Up (DTPU)" }
    }
  ]
};

const galleryItems = [
  {
    id: 1,
    title: 'Commercial Panel Upgrade – Brooklyn Supermarket',
    category: 'Commercial',
    image:
      'https://public.readdy.ai/ai/img_res/f7af5e3ad39a47f41331e157be3f755b.jpg',
  },
  {
    id: 2,
    title: 'Linear Lighting Installation – Retail Store',
    category: 'Commercial',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20linear%20LED%20lighting%20system%20installed%20on%20ceiling%20of%20large%20retail%20store%2C%20bright%20even%20illumination%20across%20wide%20aisles%2C%20clean%20white%20ceiling%20with%20recessed%20and%20linear%20fixtures%2C%20professional%20commercial%20lighting%20installation&width=800&height=600&seq=gallery-2&orientation=landscape',
  },
  {
    id: 3,
    title: 'Residential Panel Replacement – Staten Island',
    category: 'Residential',
    image:
      'https://readdy.ai/api/search-image?query=New%20residential%20electrical%20panel%20installed%20in%20home%20utility%20room%2C%20modern%20circuit%20breaker%20box%20with%20neat%20labeled%20wiring%2C%20clean%20white%20panel%20door%20open%20showing%20organized%20breakers%2C%20professional%20home%20electrical%20upgrade&width=800&height=600&seq=gallery-3&orientation=landscape',
  },
  {
    id: 4,
    title: 'EMT Conduit System – Warehouse',
    category: 'Industrial',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20EMT%20conduit%20installation%20in%20large%20industrial%20warehouse%2C%20organized%20metal%20conduit%20runs%20along%20ceiling%20and%20walls%2C%20neat%20parallel%20pipe%20routing%20with%20junction%20boxes%2C%20industrial%20electrical%20infrastructure%20with%20proper%20supports%20and%20clamps&width=800&height=600&seq=gallery-4&orientation=landscape',
  },
  {
    id: 5,
    title: 'EV Charger Installation – Private Garage',
    category: 'Residential',
    image:
      'https://readdy.ai/api/search-image?query=Level%202%20electric%20vehicle%20charger%20mounted%20on%20garage%20wall%2C%20clean%20professional%20installation%20with%20dedicated%20circuit%20wiring%2C%20modern%20white%20EV%20charging%20station%20with%20cable%20management%2C%20residential%20garage%20with%20polished%20concrete%20floor&width=800&height=600&seq=gallery-5&orientation=landscape',
  },
  {
    id: 6,
    title: 'Smart Home Wiring – Queens Renovation',
    category: 'Residential',
    image:
      'https://readdy.ai/api/search-image?query=Smart%20home%20electrical%20wiring%20installation%20in%20renovated%20house%2C%20organized%20low%20voltage%20wiring%20panel%20with%20smart%20switches%20and%20automation%20hub%2C%20clean%20structured%20wiring%20cabinet%20with%20labeled%20cables%2C%20modern%20home%20automation%20electrical%20setup&width=800&height=600&seq=gallery-6&orientation=landscape',
  },
  {
    id: 8,
    title: 'Tenant Fit-Out – Manhattan Office',
    category: 'Commercial',
    image:
      'https://readdy.ai/api/search-image?query=Commercial%20office%20electrical%20fit-out%20in%20Manhattan%2C%20recessed%20lighting%20installation%20in%20modern%20open%20plan%20office%20ceiling%2C%20organized%20electrical%20conduit%20and%20wiring%20above%20drop%20ceiling%20tiles%2C%20professional%20commercial%20tenant%20improvement%20electrical%20work&width=800&height=600&seq=gallery-8&orientation=landscape',
  },
  {
    id: 11,
    title: 'Outdoor Landscape Lighting – Brooklyn Home',
    category: 'Residential',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20outdoor%20landscape%20lighting%20installation%20around%20residential%20home%2C%20pathway%20lights%20and%20uplighting%20on%20trees%20and%20shrubs%2C%20warm%20LED%20outdoor%20fixtures%20illuminating%20front%20yard%20at%20dusk%2C%20beautiful%20curb%20appeal%20with%20professional%20electrical%20landscape%20lighting&width=800&height=600&seq=gallery-11&orientation=landscape',
  },
  {
    id: 12,
    title: 'Demo & Retrofit – Old Factory Rewire',
    category: 'Industrial',
    image:
      'https://readdy.ai/api/search-image?query=Industrial%20electrical%20retrofit%20project%20in%20old%20factory%20building%2C%20new%20modern%20wiring%20replacing%20outdated%20knob%20and%20tube%20electrical%20system%2C%20organized%20new%20conduit%20runs%20alongside%20demolished%20old%20wiring%2C%20professional%20industrial%20electrical%20modernization%20project&width=800&height=600&seq=gallery-12&orientation=landscape',
  },
  {
    id: 13,
    title: 'Staircase LED Lighting – Luxury Residential',
    category: 'Residential',
    image:
      'https://static.readdy.ai/image/538b4e65f17508bb0aa3f7f0e8fac3a5/81f559a6eaa984461eae3fb03a77c571.jpeg',
  },
  {
    id: 14,
    title: 'Conduit & Panel Installation – Commercial Building',
    category: 'Commercial',
    image:
      'https://static.readdy.ai/image/538b4e65f17508bb0aa3f7f0e8fac3a5/8b2903dcda2a66fe61f1960d46d710d6.jpeg',
  },
  {
    id: 15,
    title: 'Luxury Kitchen Electrical – Manhattan Penthouse',
    category: 'Residential',
    image:
      'https://static.readdy.ai/image/538b4e65f17508bb0aa3f7f0e8fac3a5/b6a92e3cad04967a44b34662efbce714.jpeg',
  },
  {
    id: 16,
    title: 'Penthouse Terrace Lighting – Manhattan',
    category: 'Residential',
    image:
      'https://static.readdy.ai/image/538b4e65f17508bb0aa3f7f0e8fac3a5/56ed799bfabdc1010d50daa83f43139a.jpeg',
  },
  {
    id: 17,
    title: 'Large Commercial Panel – Multi-Circuit Installation',
    category: 'Commercial',
    image:
      'https://static.readdy.ai/image/538b4e65f17508bb0aa3f7f0e8fac3a5/14b6be1835e5d674c10da67ea139ca7c.jpeg',
  },
  {
    id: 18,
    title: 'Conduit & Cable Tray – Parking Structure',
    category: 'Commercial',
    image:
      'https://static.readdy.ai/image/538b4e65f17508bb0aa3f7f0e8fac3a5/a9b8228df5d671bf9e0dad07891f8f4c.jpeg',
  },
];

const categories = ['All', 'Residential', 'Commercial', 'Industrial'];

const GalleryPage = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const filtered =
    activeCategory === 'All'
      ? galleryItems
      : galleryItems.filter((item) => item.category === activeCategory);

  const openLightbox = (index: number) => setLightboxIndex(index);
  const closeLightbox = () => setLightboxIndex(null);
  const prevImage = () =>
    setLightboxIndex((i) =>
      i !== null ? (i - 1 + filtered.length) % filtered.length : null,
    );
  const nextImage = () =>
    setLightboxIndex((i) => (i !== null ? (i + 1) % filtered.length : null));

  const categoryColors: Record<string, string> = {
    Residential: 'bg-emerald-100 text-emerald-700',
    Commercial: 'bg-amber-100 text-amber-700',
    Industrial: 'bg-slate-100 text-slate-700',
  };

  // Background SVG for hero section – extracted to a style object to avoid
  // Tailwind's arbitrary value parsing issues (the previous bg-[url(...)] caused
  // a compile‑time “Expected identifier but found '/'” error).
  const heroBackgroundStyle: React.CSSProperties = {
    backgroundImage:
      "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')",
    opacity: 0.1,
    inset: 0,
    position: 'absolute' as const,
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.async = true;
    script.textContent = JSON.stringify(GALLERY_SCHEMA);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-secondary via-secondary to-gray-800 overflow-hidden">
        <div style={heroBackgroundStyle} />
        <div className="relative max-w-[1280px] mx-auto px-6 lg:px-12 text-center">
          <p className="text-primary text-xs font-bold tracking-[0.2em] uppercase mb-4">
            OUR WORK
          </p>
          <h1 className="text-6xl font-bold text-white mb-6">Project Gallery</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
            A look at some of our completed electrical projects across NYC —
            from residential upgrades to large‑scale commercial installations.
          </p>
        </div>
      </section>

      {/* Filter Bar */}
      <section className="sticky top-20 z-30 bg-white border-b border-gray-100 shadow-sm">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-12 py-4 flex items-center gap-3 flex-wrap">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeCategory === cat
                  ? 'bg-primary text-white shadow-md'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {cat}
              <span className="ml-2 text-xs opacity-70">
                ({cat === 'All' ? galleryItems.length : galleryItems.filter((g) => g.category === cat).length})
              </span>
            </button>
          ))}
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-12">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((item, index) => (
              <div
                key={item.id}
                onClick={() => openLightbox(index)}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer hover:-translate-y-1"
              >
                <div className="w-full h-56 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <span
                    className={`inline-block text-xs font-bold px-3 py-1 rounded-full mb-3 ${categoryColors[item.category]}`}
                  >
                    {item.category}
                  </span>
                  <h3 className="text-base font-bold text-secondary leading-snug group-hover:text-primary transition-colors duration-200">
                    {item.title}
                  </h3>
                  <div className="mt-3 flex items-center text-primary text-sm font-medium">
                    <span>View Photo</span>
                    <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform duration-200"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="text-center py-24 text-gray-400">
              <i className="ri-image-line text-5xl mb-4 block"></i>
              <p className="text-lg">No photos in this category yet.</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-primary">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">Ready to Start Your Project?</h2>
          <p className="text-white/90 text-lg mb-8 max-w-xl mx-auto">
            Contact us today for a free consultation and quote on your electrical project.
          </p>
          <a
            href="/contact"
            className="inline-flex items-center justify-center bg-white text-primary px-10 py-4 rounded-full font-bold text-base hover:bg-gray-100 transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer"
          >
            Request a Free Quote
            <i className="ri-arrow-right-line ml-2 text-lg"></i>
          </a>
        </div>
      </section>

      <Footer />

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center"
          onClick={closeLightbox}
        >
          {/* Close */}
          <button
            onClick={closeLightbox}
            className="absolute top-5 right-6 w-10 h-10 flex items-center justify-center text-white text-2xl hover:text-gray-300 transition-colors cursor-pointer z-10"
          >
            <i className="ri-close-line"></i>
          </button>

          {/* Prev */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
            className="absolute left-4 w-12 h-12 flex items-center justify-center text-white text-3xl hover:text-primary transition-colors cursor-pointer z-10"
          >
            <i className="ri-arrow-left-s-line"></i>
          </button>

          {/* Image */}
          <div className="max-w-4xl w-full mx-16" onClick={(e) => e.stopPropagation()}>
            <div className="w-full h-[60vh] rounded-xl overflow-hidden">
              <img
                src={filtered[lightboxIndex].image}
                alt={filtered[lightboxIndex].title}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="mt-4 flex items-center justify-between px-1">
              <div>
                <span
                  className={`inline-block text-xs font-bold px-3 py-1 rounded-full mr-3 ${categoryColors[filtered[lightboxIndex].category]}`}
                >
                  {filtered[lightboxIndex].category}
                </span>
                <span className="text-white font-semibold text-base">
                  {filtered[lightboxIndex].title}
                </span>
              </div>
              <span className="text-gray-400 text-sm whitespace-nowrap">
                {lightboxIndex + 1} / {filtered.length}
              </span>
            </div>
          </div>

          {/* Next */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
            className="absolute right-4 w-12 h-12 flex items-center justify-center text-white text-3xl hover:text-primary transition-colors cursor-pointer z-10"
          >
            <i className="ri-arrow-right-s-line"></i>
          </button>
        </div>
      )}
    </div>
  );
};

export default GalleryPage;
